module.exports = __webpack_public_path__ + "static/media/plus.ff9dfe3c.svg";